var _defs, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSandbox(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sandbox_svg__[object_Object]a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4DB1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#148CFC"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Sandbox_svg__[object_Object]a)",
    fillRule: "evenodd",
    d: "M11.86 10.27a.375.375 0 01-.532 0l-5.85-5.852V1.355A1.354 1.354 0 003.166.397L.397 3.167a1.354 1.354 0 00.957 2.312h3.067l5.85 5.852a.375.375 0 010 .53L8.68 13.453a.375.375 0 000 .53l2.917 2.918a3.75 3.75 0 105.304-5.305L13.984 8.68a.375.375 0 00-.53 0l-1.595 1.59zM3.657 2.027a.187.187 0 01.32.132v1.632a.188.188 0 01-.188.187H2.16a.188.188 0 01-.133-.32l1.63-1.631z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandbox);
export default ForwardRef;